<template>
	<div>
		<div class="button-right">
			<el-button size="mini" @click="showBatchDialog">{{ $t("customer.batchOpertion") }}</el-button>
		</div>
		<!-- 我的客户列表 -->
		<el-table ref="customerTable" :data="customerData" style="width: 100%" v-loading="loading">
			<el-table-column prop="customer_id" :label="$t('customer.customerCode')" width="150">
				<template slot-scope="scope">
					<span>{{ scope.row.customer_id | removeFrontZero }}</span>
				</template>
			</el-table-column>
			<el-table-column prop="customer_name" width="180" :label="$t('customer.customerName')"> </el-table-column>
			<el-table-column prop="warehouse" :label="$t('customer.warehouse')" width="140"> </el-table-column>
			<el-table-column prop="clients_count" :label="$t('customer.customerBindingQuantity')" width="280"> </el-table-column>
			<el-table-column prop="product_latest_count" :label="$t('customer.maintenanceQuantity')" width="340"> </el-table-column>
			<el-table-column prop="cz" :label="$t('customer.operate')">
				<template slot-scope="scope">
					<el-button size="mini" @click="customerSetting(scope.row.customer_id)">{{ $t("customer.customerBinding") }}</el-button>
					<el-button size="mini" @click="commoditySetting(scope.row.customer_id)">{{ $t("customer.productSettings") }}</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!-- 批量操作弹窗 -->
		<customer-batch-operation-dialog
			:visible.sync="batchDialogVisible"
			:customer-list="customerData"
			@success="handleBatchSuccess"
			@close="batchDialogVisible = false"
		/>
	</div>
</template>
<script>
import { getCustomers } from "@/services/api-v2/api-v2";
import CustomerBatchOperationDialog from "./components/customer-batch-opertion-dialog.vue";
export default {
	name: "customer",
	components: {
		CustomerBatchOperationDialog,
	},
	data() {
		return {
			// 我的客户数据
			customerData: [],
			// 加载中
			loading: false,
            // 批量操作弹窗显示状态
			batchDialogVisible: false,
		};
	},

	created() {
		// 我的客户初始化数据
		this.initMyCustomerData();
	},
	methods: {
		// 初始化数据
		async initMyCustomerData() {
			this.loading = true;
			try {
				const { data } = await getCustomers();
				this.customerData = data;
			} catch (error) {
				this.$message.error(error);
			} finally {
				this.loading = false;
			}
		},
        // 显示批量操作弹窗
		showBatchDialog() {
			this.batchDialogVisible = true;
		},
		// 批量操作成功后的回调
		handleBatchSuccess() {
			// 刷新列表数据
			this.initMyCustomerData();
		},
		//点击客户绑定
		customerSetting(customerId) {
			this.$router.push({ path: `/setting/customer-phone/${customerId}` });
		},
		// 点击商品设置
		commoditySetting(customerId) {
			this.$router.push({ path: `/setting/customer-product/${customerId}` });
		},
	},
};
</script>

<style scoped>
.button-right {
	text-align: right;
	margin-bottom: 10px;
}
</style>
